import React, { useEffect, useState } from "react";
import { MainDiv, ParentDiv, WizardContent } from "../styles";
import Header from "../common/header";
import Loader from "../common/loader";
import ProductStatus from "../common/productsStatus/productStatus";
import ProgressBar from "../common/progressBar";
import WelcomeGreet from "../common/welcome-greet/welcome-greet";
import { useLocation, useNavigate } from "react-router-dom";

const SummaryView = () => {
    let [isLoading, setLoader] = useState(true);
    const [platformList, setPlatformList] = useState([]);
    const [productDetails, setProductDetails] = useState({ status: "", productStatus: "", statusIcon: "", btnIcon: "", msgContent: "" });
    const location = useLocation();
    const navigate = useNavigate();
    
    const data = location.state;
    useEffect(() => {
        const appList = JSON.parse(window.localStorage.getItem("appList"));
        setPlatformList(appList);
        if (data && data.error) {
            setProductDetails({
                status: "fail", productStatus: "Request not submitted successfully", statusIcon: "fas fa-times-circle",
                msgContent: `We have encountered an error while submitting your request for Outbound List Manager - installation.`,
            });
        } else {
            setProductDetails({
                status: "success", productStatus: "Request submitted successfully", statusIcon: "fas fa-check-circle",
                msgContent: `The installation of the Outbound List Manager application is now complete.`,
            });
        }

        let integrationStatus = sessionStorage.getItem('integrationDetection');
        if (integrationStatus ) {
            // JSon parse the value
            integrationStatus = JSON.parse(integrationStatus);
            if (integrationStatus.found == false){
                let msg = integrationStatus.message;
                setProductDetails({
                    status: "fail", productStatus: "Request not submitted successfully", statusIcon: "fas fa-times-circle",
                    msgContent: `Error during installation - ${msg}`,
                });
            }
        }

        setLoader(false);
    }, [])

    useEffect(()=>{
        if(!sessionStorage.getItem('isInstallationChecked')) {
            navigate('/index');
        }
    },[])
    return (
        <ParentDiv>
            <div id="background"></div>
            <Header tail="Summary"></Header>

            <WizardContent>
                {(isLoading) &&
                    <Loader></Loader>
                }
                <WelcomeGreet tabTitle="Done"></WelcomeGreet>
            </WizardContent>

            <ProgressBar tabName="summary"></ProgressBar>

            <MainDiv>
                <ProductStatus {...productDetails}></ProductStatus>
                <div className="summary">
                    {platformList && platformList?.map((data, index) => {
                        return <p key={index} className="tobeinstall">{` ${index + 1}. ${data.tenantName}(${data.platformName})`}</p>
                    })
                    }
                </div>
            </MainDiv>
        </ParentDiv>
    )
}

export default SummaryView;